<template>
    <b-container fluid>
        <b-row no-gutters>
            <b-col v-if="ishost" class="w-100">
                <b-button-toolbar>
                    <b-button-group v-if="!autoconnect" size="sm" style="font-size: 0.5em;">
                        <b-button v-on:click="initRTC" :disabled="ready.value">Init</b-button>
                        <b-button v-on:click="connectChannel" :disabled="!ready.value || connected.value" >Connect Channel</b-button>
                        <b-button v-on:click="leaveChannel" :disabled="!connected.value" >Leave Channel</b-button>
                        <b-button v-on:click="startStream" :disabled="!connected.value || published.value" >Start Stream</b-button>
                        <b-button v-on:click="stopStream" :disabled="!published.value" >Stop Stream</b-button>
                    </b-button-group>
                </b-button-toolbar>
            </b-col>
        </b-row>
        <b-row no-gutters>
            <b-col class="w-100">
                <status-panel :status="statuspanel" style="min-width:300px;" id="popover-target-1"></status-panel>
                <b-popover target="popover-target-1" triggers="hover" placement="top">
                    <template v-slot:title>Active remote streams</template>
                    <div v-for="(item, key) in rtc.remoteStreams" :key="key">
                        <span>{{item.id}}</span>
                    </div>
                </b-popover>
            </b-col>
        </b-row>
    </b-container>

</template>

<script>
    import AgoraRTC from 'agora-rtc-sdk';
    import StatusPanel from './StatusPanel';

    export default {
        name: "Agora_RTC",
        components:{
            StatusPanel
        },
        props: {
            role: {
                type: String,
                default: 'audience'
            },
            username: {
                type: String
            },
            channel: {
                type: String
            },
            autoconnect: {
                type: Boolean,
                default: false
            },
            ishost: {
                type: Boolean,
                default: false
            },
            audio: {
                type: Boolean,
                default: true
            },
            video: {
                type: Boolean,
                default: false
            },
            preferredinput: {
                type: String,
                default: null
            }

        },
        data: function () {
            return {
                option: {
                    appID: "eda5d991b3664dcda82ef22799493c5b",
                    // uid: 'admin',
                    // token: "Your token"
                },
                rtc: {
                    client: null,
                    localStream: null,
                    remoteStreams: {},
                    params: {}
                },
                ready: {label: 'Rdy', variant: 'outline-dark', value: false},
                connected: {label: 'Conn', variant: 'outline-dark', value: false},
                published: {label: 'Str', variant: 'outline-dark', value: false},
                receiving: {label: 'Rcv', variant: 'outline-dark', value: false},
                statuspanel: []
            }
        },
        computed:{
            uid: function () {
                return this.username + '#' + this.ticket;
            }
        },
        methods:{
            initRTC: function(){
                //init RTC Client
                this.rtc.client = AgoraRTC.createClient({mode: "live", codec: "h264"});

                //As client
                this.rtc.client.on("stream-added", function (evt) {
                    let remoteStream = evt.stream;
                    let id = remoteStream.getId();
                    if (id !== this.rtc.params.uid) {
                        this.rtc.client.subscribe(remoteStream, function (err) {
                            console.log("stream subscribe failed", err);
                        })
                    }
                    console.log('stream-added remote-uid: ', id);
                }.bind(this));

                this.rtc.client.on("stream-subscribed", function (evt) {
                    let remoteStream = evt.stream;
                    this.updateRemoteStreamList(remoteStream);
                    this.$emit('stream-started', remoteStream);
                }.bind(this))

                this.rtc.client.on("stream-removed", function (evt) {
                    console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%');
                    let remoteStream = evt.stream;
                    this.updateRemoteStreamList(remoteStream, true);
                    this.$emit('stream-stopped', remoteStream);
                }.bind(this))

                this.rtc.client.on("peer-leave", function (evt) {
                    console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%');
                    this.updateRemoteStreamList(null, true, evt.uid);
                    this.$emit('peer-leave', evt.uid);
                }.bind(this))

                //As local
                this.rtc.client.on("stream-published", function () {
                    this.published.value = true;
                }.bind(this))

                this.rtc.client.on("connected", function() {
                    // console.log("connected");
                    this.$emit('rtc-connected');
                }.bind(this))

                this.rtc.client.init(this.option.appID, function () {
                    console.log("init success");
                    this.ready.value = true;
                    if(this.autoconnect){
                        this.connectChannel();
                    }
                }.bind(this), (err) => {
                    console.error(err);
                });
            },
            connectChannel : function() {
                // Join a channel
                if(!this.connected.value){
                    this.rtc.client.join(this.option.token ? this.option.token : null, this.channel, this.username, function (uid) {
                        console.log("join channel: " + this.channel + " success, uid: " + uid);
                        this.rtc.params.uid = uid;
                        this.connected.value = true;

                    }.bind(this), function(err) {
                        console.error("client join failed", err)
                    })
                }
            },
            leaveChannel: function(){
                this.stopStream();
                // Leave the channel
                this.rtc.client.leave(function () {
                    // Stop playing the local stream
                    // this.rtc.localStream.stop();
                    // Close the local stream
                    // this.rtc.localStream.close();
                    this.rtc.remoteStreams = {};
                    this.connected.value = false;
                    console.log("client leaves channel success");
                }.bind(this), function (err) {
                    console.log("channel leave failed");
                    console.error(err);
                })
            },
            startStream : function() {
                // Create a local stream
                if(!this.rtc.localStream){
                    this.rtc.localStream = AgoraRTC.createStream({
                        streamID: this.rtc.params.uid,
                        audio: this.audio,
                        microphoneId: this.preferredinput,
                        video: this.video,
                        screen: false,
                    })

                    // Initialize the local stream
                    this.rtc.localStream.init(function () {
                        console.log("init local stream success");
                        // play stream with html element id "local_stream"
                        // this.rtc.localStream.play("local_stream");
                        this.$emit('local-stream-started', this.rtc.localStream);

                        // Publish the local stream
                        this.rtc.client.publish(this.rtc.localStream, function (err) {
                            console.log("publish failed");
                            console.error(err);
                        })

                    }.bind(this), function (err) {
                        console.error("init local stream failed ", err);
                    });
                } else {
                    // Publish the local stream
                    this.rtc.client.publish(this.rtc.localStream, function (err) {
                        console.log("publish failed");
                        console.error(err);
                    })
                }
            },
            stopStream: function (){
                if(this.rtc.localStream){
                    this.rtc.client.unpublish(this.rtc.localStream, function(err) {
                        console.log("un publish failed");
                        console.log(err);
                    });

                    this.published.value = false;
                    //this.rtc.localStream.close();
                    //this.rtc.localStream = null;
                }
            },
            updateRemoteStreamList(_stream, _remove=false, _id=null){
                let id = null;
                if(_id){
                    id =_id;
                } else {
                    id = _stream.getId();
                }

                if(_remove){
                    this.$delete(this.rtc.remoteStreams, id);
                } else {
                    this.$set(this.rtc.remoteStreams, id, {id: id, stream: _stream});
                }

                if(this.rtc.remoteStreams){
                    if (Object.keys(this.rtc.remoteStreams).length > 0){
                        this.receiving.value = true;
                        return;
                    }
                }
                this.receiving.value = false;
            },
            setCoHost: function(_key, _enable=true) {
                if(_key === this.username){
                    if(_enable){
                        this.rtc.client.setClientRole("host", function(e) {
                            if (!e) {
                                console.log("setHost success");
                                this.startStream();
                            } else {
                                console.log("setHost error", e);
                            }
                        }.bind(this));
                    } else {
                        this.rtc.client.setClientRole("audience", function(e) {
                            if (!e) {
                                console.log("setHost success");
                                this.stopStream();
                            }
                        }.bind(this));
                    }
                    return true;
                }
                return false;
            },
            isStreaming: function(){
                return this.published.value;
            },
            initAndListDevices(){
                const tempAudioStream = AgoraRTC.createStream({
                    audio: true,
                    video: false
                });

                const audioPermissionOK = new Promise(resolve => {
                    tempAudioStream.init(() => resolve(null), (e) => resolve(e));
                });

                Promise.all([audioPermissionOK]).then(res => {
                    if (res[0] !== null) {
                        console.warn("create audio temp stream failed!", res[0]);
                    }

                    // After the capture, call getDevices to get device information
                    AgoraRTC.getDevices(info => {
                        tempAudioStream.close();
                        let audiodevices = info.filter(function (device) {
                            return device.kind === "audioinput";
                        });
                        this.$emit('audio-devices', audiodevices)
                    });
                });

            },
            testDevices(_elementid, _audiodeviceid, videodeviceid=null){
                let uid = Math.floor(Math.random()*10000);

                let stream = AgoraRTC.createStream({
                    streamID: uid,
                    // Set audio to true if testing microphone
                    audio: true,
                    microphoneId: _audiodeviceid,
                    // Set video to true if testing camera
                    video: !!videodeviceid,
                    cameraId: videodeviceid,
                    screen: false
                });

                // Initialize the stream
                stream.init(function(){
                    stream.play(_elementid);
                })
                return stream;
            }
        },
        mounted(){
            this.$nextTick(function () {
                this.initRTC();
                window.addEventListener('beforeunload', this.leaveChannel);
                /*if(this.autoconnect){
                this.initRTC();
                }*/

                this.statuspanel.push(this.ready);
                this.statuspanel.push(this.connected);
                this.statuspanel.push(this.published);
                this.statuspanel.push(this.receiving);

                this.initAndListDevices();
            })
        },
        beforeDestroy: function () {
            window.removeEventListener('beforeunload', this.leaveChannel);
            this.leaveChannel();
        },
    }
</script>

<style scoped>

    .statusled {
        font-size:0.8em;
        float:left;
    }
    .statusled-text {
        font-size:0.7em;
        margin-left:5px;
        float:left;
    }

</style>
